import { render, staticRenderFns } from "./RegistrationIssuesPage.vue?vue&type=template&id=5f4567c9"
import script from "./RegistrationIssuesPage.vue?vue&type=script&lang=js"
export * from "./RegistrationIssuesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports